import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'fieldTruncateEllipsis' })
export class fieldTruncateEllipsisPipe implements PipeTransform {
  transform(value: string, limit = 20, trail = '...'): string {
    const searchValue = /(\r\n|\n|\r)/g;
    return value.length > limit ? (value.substring(0, limit) + trail).replace(searchValue, '<br>') : value.replace(searchValue, '<br>');
  }
}
